import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId, useState } from 'react';
import styles from './Textarea.module.scss';
const normalizeSize = (size) => {
    if (size == null)
        return undefined;
    return typeof size === 'number' ? `${size}px` : size;
};
export const Textarea = ({ value, onChange, label, width, height, resizable = true, id: propId, }) => {
    const generatedId = useId();
    const textareaId = propId || generatedId;
    const [isFocused, setIsFocused] = useState(false);
    const textareaClasses = [
        styles.textarea,
        isFocused ? styles['textarea--focused'] : '',
        value && value.length > 0 ? styles['textarea--filled'] : '',
        !resizable ? styles['textarea--no-resize'] : '',
    ]
        .filter(Boolean)
        .join(' ');
    const combinedStyles = {
        ...(width != null ? { width: normalizeSize(width) } : {}),
        ...(height != null ? { height: normalizeSize(height) } : {}),
    };
    const handleChange = (e) => {
        onChange(e.target.value);
    };
    return (_jsxs("div", { className: styles['textarea-wrapper'], children: [label && (_jsx("label", { htmlFor: textareaId, className: styles.textarea__label, children: label })), _jsx("textarea", { id: textareaId, className: textareaClasses, value: value, style: combinedStyles, onChange: handleChange, onFocus: () => setIsFocused(true), onBlur: () => setIsFocused(false) })] }));
};
